import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Col, Nav } from "react-bootstrap";
import { Container, Row } from "react-bootstrap";
import BackToTopButton from "../../components/BackToTopButton";

const Settings = () => {
    return (
        <Container fluid className="p-4 h-100 d-flex flex-column">
            <Row>
                <Col>
                    <Nav variant="pills">
                        <Nav.Item>
                            <Nav.Link as={NavLink} to={"password"} eventKey="password">
                                Password
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={NavLink} to={"playlist_autopilot"} eventKey="playlist_autopilot">
                                Playlist Autopilot
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
            </Row>
            <hr />
            <Outlet />
            <BackToTopButton />
        </Container>
    );
};

export default Settings;
